import { useEffect, useState } from "react";
import { ArrowRight, Newspaper } from "lucide-react";
import { Link } from "react-router-dom";
import api from "../../lib/api";

export default function NewsInsights() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news/public?limit=3")
      .then((r) => setItems(r.data.items || r.data.articles || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="relative overflow-hidden bg-slate-50 py-20 sm:py-24" data-testid="news-insights">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-saffron">News & Shipping Insights</p>
            <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">
              FROM THE INDIAFAST WORLD
            </h2>
          </div>
          <Link to="/p/news" data-testid="news-insights-all"
                className="group inline-flex items-center gap-2 text-sm font-bold text-navy transition-colors hover:text-saffron">
            View all articles <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {items.slice(0, 3).map((a, i) => (
            <Link key={a.slug || a.id || i} to={`/p/news/${a.slug || a.id}`} data-testid={`news-card-${i}`}
                  className="group flex flex-col rounded-3xl border border-slate-200 bg-white p-7 shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-saffron/40 hover:shadow-xl">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-saffron/10 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-saffron">
                <Newspaper className="h-3 w-3" /> {a.category || "Insights"}
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-navy transition-colors group-hover:text-saffron">
                {a.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-500">
                {(a.excerpt || "").slice(0, 130) || "Read the full update from IndiaFast."}
              </p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold text-navy transition-colors group-hover:text-saffron">
                Read article <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
